const NUMERIC_COLUMN_TYPES = new Set([
  'NUMBER',
  'DECIMAL',
  'DEC',
  'NUMERIC',
  'INT',
  'INTEGER',
  'BIGINT',
  'SMALLINT',
  'TINYINT',
  'BYTEINT',
  'FLOAT',
  'FLOAT4',
  'FLOAT8',
  'DOUBLE',
  'DOUBLE PRECISION',
  'REAL',
  'DECFLOAT',
  'FIXED',
  'LONG',
  'SHORT',
  'BYTE',
  'INT2',
  'INT4',
  'INT8',
  'INT64',
  'FLOAT64',
  'BIGNUMERIC',
  'BIGDECIMAL',
  'UINT8',
  'UINT16',
  'UINT32',
  'UINT64',
  'UINT128',
  'UINT256',
  'INT16',
  'INT32',
  'INT128',
  'INT256',
  'FLOAT32',
  'BFLOAT16',
  'DECIMAL32',
  'DECIMAL64',
  'DECIMAL128',
  'DECIMAL256',
]);

const TYPE_WRAPPER = /^(?:NULLABLE|LOWCARDINALITY)\((.*)\)$/;

export function normalizeColumnType(type: string): string {
  let normalized = type.trim().toUpperCase();
  let wrapped = TYPE_WRAPPER.exec(normalized);
  while (wrapped) {
    normalized = wrapped[1].trim();
    wrapped = TYPE_WRAPPER.exec(normalized);
  }
  return normalized.replace(/\s*\(.*\)$/, '');
}

export function isNumericColumnType(type?: string): boolean {
  if (!type) {
    return false;
  }
  return NUMERIC_COLUMN_TYPES.has(normalizeColumnType(type));
}
